import http from "../config/http-common";
import axios from "axios";
import authHeader from "./auth-header";

import server from "../config/server.config";

const API_URL = server.host + ":" + server.port + "/api/user/";

class InventoryDataService {

  getAll(params) {
    const response = http.get("/api/user/inventories", {
      headers: authHeader(),
      params: params,
    });
    // console.log("response ", response);
    return response;
  }

  get(id) {
    return http.get(`/api/user/inventories/${id}`, { headers: authHeader() });
  }

  create(data) {
    // console.log("data ", data);
    return http.post("/api/user/inventories/add", data, { headers: authHeader() });
  }

  update(id, data) {
    console.log("data ", data)
    return http.put(`/api/user/inventories/${id}`, data, { headers: authHeader() });
  }

  delete(id) {
    return http.delete(`/api/user/inventories/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return http.delete(`/api/user/inventories`, { headers: authHeader() });
  }

  findByName(name) {
    return http.get(`/api/user/inventories?name=${name}`, {
      headers: authHeader(),
    });
  }

  getInventory(user) {
    return axios.get(`${API_URL}inventories/${user.id}`, {
      timeout: 1000,
      headers: authHeader(),
    });
  }

  postInventory(user, items) {
    const data = {
      userid: user.id,
      // Inventory: items,
      items: items,
    };
    // console.log(data);
    return axios.post(API_URL + "inventories", data, {
      // `method` is the request method to be used when making the request
      method: "post", // default "get"
      headers: authHeader(),
      timeout: 1000, // default is `0` (no timeout)
    });
  }


}
export default new InventoryDataService();



